import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { ARGENTINE_NAMES, ARGENTINE_CITIES } from '../data/content';
function randomFrom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface Sale {
  id: number;
  name: string;
  city: string;
  mins: number;
}
export function SalesPopup() {
  const [sale, setSale] = useState<Sale | null>(null);
  useEffect(() => {
    let counter = 0;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const show = () => {
      counter += 1;
      setSale({
        id: counter,
        name: randomFrom(ARGENTINE_NAMES),
        city: randomFrom(ARGENTINE_CITIES),
        mins: Math.floor(Math.random() * 12) + 1
      });
      hideTimeout = setTimeout(() => setSale(null), 5000);
    };
    const first = setTimeout(show, 4000);
    const interval = setInterval(show, 13000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4" data-id="element-36">
      <AnimatePresence data-id="element-37">
        {sale && <motion.div key={sale.id} initial={{
        opacity: 0,
        y: 40,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 22
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-gold/40 bg-white p-3 shadow-2xl" data-id="element-38">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-39">
              <ShoppingBagIcon className="h-5 w-5 text-gold" data-id="element-40" />
            </div>
            <div className="flex-1 leading-tight" data-id="element-41">
              <p className="text-sm font-bold text-navy-deep" data-id="element-42">
                {sale.name} de {sale.city}
              </p>
              <p className="text-xs text-slate-500" data-id="element-43">
                compró el Volley Pro System · hace {sale.mins} min
              </p>
            </div>
            <button type="button" onClick={() => setSale(null)} className="text-slate-400 hover:text-slate-600" aria-label="Cerrar" data-id="element-44">
              <XIcon className="h-4 w-4" data-id="element-45" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}